import React from 'react';
import * as ST from './styled';
import { ThemeProvider } from 'styled-components';

const theme = {
    flexboxgrid: {
        breakpoints: {
            xs: 0,
            sm: 48,
            md: 80,
            lg: 100,
        },
    },
};

const Card = (
    {
        headerBlock,
        imageBlock,
        titleBlock,
        descriptionBlock,
        purchaseBlock,
        dataTest,
        xs = 12,
        sm = 6,
        md = 4,
        lg = 3,
        display = 'block',
        oneRow = false,
    },
) => {
    return (
        <ThemeProvider theme={theme}>
            <ST.Col xs={xs} sm={sm} md={md} lg={lg} data-test={dataTest} display={display} oneRow={oneRow}>
                <ST.Card oneRow={oneRow}>
                    {false !== headerBlock && <ST.HeaderBlock>{headerBlock}</ST.HeaderBlock>}
                    {false !== imageBlock && <ST.ImageBlock>{imageBlock}</ST.ImageBlock>}
                    {false !== titleBlock && <ST.TitleBlock>{titleBlock}</ST.TitleBlock>}
                    {false !== descriptionBlock && <ST.DescriptionBlock>{descriptionBlock}</ST.DescriptionBlock>}
                    {false !== purchaseBlock && <ST.PurchaseBlock>{purchaseBlock}</ST.PurchaseBlock>}
                </ST.Card>
            </ST.Col>
        </ThemeProvider>
    );
};

export default Card;
